export const dummyCarts = {
  cartId: '2l1sqm54jic1a91u2msukjf5llhi5jvq',
  items: [
    {
      id: '7f8543c6-b65e-40fd-bbf8-f057d2444871',
      product_name: 'Demon Slayer Executive Logo Shirt - Off White',
      sell_price: 179900,
      product_assets: [
        {
          assets_type: 'image',
          assets_url:
            'https://dev-storage.jubelio.com/demo-c/images/jstorev2/627d2b73-268a-437f-adda-693f6d6b0c8e.jpeg',
        },
      ],
      quantity: 1,
      variants: [
        {
          option_id: '7f8543c6-b65e-40fd-bbf8-f057d2444871',
          variant_id: '7f8543c6-b65e-40fd-bbf8-f057d2444871',
          label: 'Off White',
        },
        {
          option_id: '4d844d90-1e8a-4a13-9194-32900db99723',
          variant_id: '4d844d90-1e8a-4a13-9194-32900db99723',
          label: 'M',
        },
      ],
      sku: 'Exe-Demon-Off_White-M',
      discount_price: 10000,
      retail_price: 0,
      pricebook_id: '',
    },
  ],
  subtotal: 179900,
  grand_total: 242000,
  shipping_cost: 9000,
  tax_amount: 23981.99,
  is_tax_included: true,
  discount_amount: 10000,
  total_promotion_discount: 10000,
};

export const dummyPromotions = [
  {
    promotion_id: '89a760df-e86c-4909-bcfd-487d696b8145',
    promotion_name: 'Dummy promotion for preview',
    is_overlap: false,
    multiply: 'custom',
    max_multiply: 0,
    priority: 1,
    minimum_spending: 1000000,
    created_at: '2025-05-27T18:44:56.280Z',
    use_voucher: false,
    product_rules_type: 'flexible',
    promotion_type: 4,
    limit_reward: false,
    is_limited: true,
    quota: 0,
    customer_limit: true,
    promotion_tier_id: 'b6e9b34b-87ca-4ce1-9762-4d74d55c5acd',
    product_reward: [
      {
        reward_type: 'product',
        qty: 1,
        rule_type: 'include',
        reward_items: [
          {
            item_type: 'product',
            target_id: 'b6e9b34b-87ca-4ce1-9762-4d74d55c5acd',
          },
        ],
      },
      {
        reward_type: 'product',
        qty: 1,
        rule_type: 'exclude',
        reward_items: [
          {
            item_type: 'variasi',
            target_id: 'b6e9b34b-87ca-4ce1-9762-4d74d55c5acd',
          },
        ],
      },
    ],
    discount_reward: [
      {
        reward_type: 'discount',
        discount_amount: 30,
        discount_type: 'percentage',
        max_discount_amount: 300000,
        total_discount: 300000,
      },
    ],
    counted_multiply: 0,
    total_amount: 1007000,
    include_items: {
      qty: 0,
      items: [],
    },
    exclude_items: {
      qty: 0,
      items: [],
    },
    promotion_tier: [
      {
        promotion_tier_id: 'b6e9b34b-87ca-4ce1-9762-4d74d55c5acd',
        threshold: 3000000,
      },
      {
        promotion_tier_id: 'b6e9b34b-87ca-4ce1-9762-4d74d55c5acd',
        threshold: 2000000,
      },
      {
        promotion_tier_id: 'b6e9b34b-87ca-4ce1-9762-4d74d55c5acd',
        threshold: 1000000,
      },
    ],
    promotion_specific: null,
    total_discount: 300000,
  },
];
